import {
  LIBRARY_TAXES,
  GET_ITEM_SERVICE,
  PUT_TAX_BY_ID_SERVICE,
  POST_TAX_BY_ID_SERVICE,
  GET_TAX_SERVICE,
  GET_TAX_BY_ID_SERVICE,
  GET_TAXITEMS_BY_ID_SERVICE,
  GET_TAXITEMS_CUSTOM_AMOUNT_BY_ID_SERVICE,
  GET_ITEM_CUSTOM_AMOUNT_SERVICE,
  DELETE_TAX_BY_ID_SERVICE
} from './constants'

import {
  serviceAccountErrorCallback,
  serviceAccountSuccessCallback
} from 'api/callbacks'

import {select} from 'redux-saga/effects'

export const getBusinessId = state => state.moka.user.business.id
export const getOutletId = state => state.form.search.values.outletIds[0]

export function getTaxes (params) {
  return axios.get(LIBRARY_TAXES, {params, withCredentials: true})
    .then(serviceAccountSuccessCallback)
    .catch(serviceAccountErrorCallback)
}

export function * getTaxService (params) {
  let outletId = yield select(getOutletId)
  console.log('getTaxService', outletId)
  return yield axios.get(GET_TAX_SERVICE(outletId), {params, withCredentials: false})
}

export function * getTaxDetail (id, params) {
  return yield axios.get(GET_TAX_BY_ID_SERVICE(id), {params, withCredentials: false})
}

export function * getTaxItemDetail (id, params) {
  return yield axios.get(GET_TAXITEMS_BY_ID_SERVICE(id), {params, withCredentials: false})
}

export function * getTaxItemDetailCustomAmount (id, params) {
  return yield axios.get(GET_TAXITEMS_CUSTOM_AMOUNT_BY_ID_SERVICE(id), {params, withCredentials: false})
}

export function * getItemCustomAmount (params) {
  let outletId = yield select(getOutletId)
  return yield axios.get(GET_ITEM_CUSTOM_AMOUNT_SERVICE(outletId), {params, withCredentials: false})
}

export function * filterTaxItem (categoryId, name, params) {
  let outletId = yield select(getOutletId)
  return yield axios.get(GET_ITEM_SERVICE(outletId, categoryId, name), {params, withCredentials: false})
}

export function * updateTax (id, data, params) {
  return yield axios.put(PUT_TAX_BY_ID_SERVICE(id), data, {params, withCredentials: false})
}

export function * createTax (data, params) {
  return yield axios.post(POST_TAX_BY_ID_SERVICE(), data, {params, withCredentials: false})
}

export function * deleteTax (id, params) {
  return yield axios.delete(DELETE_TAX_BY_ID_SERVICE(id), {params, withCredentials: false})
}

export function * createTaxAllOutlets (data, params) {
  return yield axios.post(POST_TAX_BY_ID_SERVICE(), data, {params, withCredentials: false})
}



// WEBPACK FOOTER //
// ./app/api/taxes/taxes.js